import { createSelector } from 'reselect';

import { selectLoanApplication } from './loanApplication.selectors';

const selectResidences = createSelector(selectLoanApplication, ({ residences }) => residences);

export const selectResidenceValues = createSelector(selectResidences, Object.values);
